import React, { FC, useRef } from 'react';
import { PlaybackComponentProps } from '../Player.types';
import ReactPlayerLazy from 'react-player/lazy';

// https://github.com/cookpete/react-player/issues/1369
if (typeof window !== 'undefined') {
  const win = window as any;
  if (!win.Vimeo && win && win.define && win.define.amd) {
    win.require(['https://player.vimeo.com/api/player.js'], (Player: any) => {
      win.Vimeo = { Player };
    });
  }
}

export const ReactPlayer: FC<PlaybackComponentProps> = ({
  src,
  playing,
  onEnded,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  const handleReady = () => {
    if (ref.current) {
      const iframe = ref.current.querySelector('iframe');

      if (iframe && !iframe.allow.includes('autoplay')) {
        iframe.setAttribute('allow', 'autoplay');
        iframe.setAttribute('src', iframe.src);
      }
    }
  };

  return (
    <div
      ref={ref}
      style={{ height: '100%', width: '100%' }}
      data-hook="react-player"
    >
      <ReactPlayerLazy
        onReady={handleReady}
        url={src}
        width="100%"
        height="100%"
        controls
        playing={playing}
        onEnded={onEnded}
      />
    </div>
  );
};
